import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StrategicPartnership() {
  return <section data-section-id="255035" id="our-capabilities" className="bg-background text-foreground ![padding:120px_24px_70px_24px]">
      <div className="mx-auto flex max-w-[800px] flex-col items-center text-center">
        <span className="mb-6 block text-sm font-mono font-semibold uppercase tracking-widest text-primary">
          Engineering Excellence
        </span>
        
        <h2 className="font-default mb-12 text-3xl font-bold leading-tight tracking-tighter text-foreground md:text-4xl lg:text-5xl lg:leading-tight">
          We prioritize quality over quantity, blending agile speed with enterprise-grade stability to forge high-performance digital products.
        </h2>
        
        <Button asChild variant="outline" size="lg" className="rounded-md border-border px-8 hover:bg-primary hover:text-primary-foreground transition-all duration-300 shadow-md">
          
        </Button>
      </div>
    </section>;
}